var _rect, _filter, _filter2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDeliFreeIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 64,
    height: 64,
    viewBox: "0 0 64 64",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_7121_143699)"
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 12,
    y: 12,
    width: 32,
    height: 32,
    rx: 16,
    fill: "url(#paint0_linear_7121_143699)",
    shapeRendering: "crispEdges"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_d_7121_143699)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_7121_143699",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 18,
    y: 18,
    width: 20,
    height: 20
  }, /*#__PURE__*/React.createElement("rect", {
    x: 18,
    y: 18,
    width: 20,
    height: 20,
    fill: "#D9D9D9",
    style: {
      fill: "#D9D9D9",
      fill: "color(display-p3 0.8510 0.8510 0.8510)",
      fillOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_7121_143699)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M28.0091 36.3356C27.6758 36.3356 27.3563 36.2731 27.0508 36.1481C26.7452 36.0231 26.4744 35.8426 26.2383 35.6064C25.8355 35.2037 25.4883 34.9398 25.1966 34.8148C24.9049 34.6898 24.4674 34.6273 23.8841 34.6273C23.1897 34.6273 22.5994 34.3842 22.1133 33.8981C21.6272 33.412 21.3841 32.8217 21.3841 32.1273C21.3841 31.5439 21.3216 31.1064 21.1966 30.8148C21.0716 30.5231 20.8077 30.1759 20.4049 29.7731C20.1688 29.537 19.9883 29.2662 19.8633 28.9606C19.7383 28.6551 19.6758 28.3356 19.6758 28.0023C19.6758 27.6689 19.7383 27.3495 19.8633 27.0439C19.9883 26.7384 20.1688 26.4676 20.4049 26.2314C20.8077 25.8287 21.0716 25.4814 21.1966 25.1898C21.3216 24.8981 21.3841 24.4606 21.3841 23.8773C21.3841 23.1828 21.6272 22.5926 22.1133 22.1064C22.5994 21.6203 23.1897 21.3773 23.8841 21.3773C24.4674 21.3773 24.9049 21.3148 25.1966 21.1898C25.4883 21.0648 25.8355 20.8009 26.2383 20.3981C26.4744 20.162 26.7452 19.9814 27.0508 19.8564C27.3563 19.7314 27.6758 19.6689 28.0091 19.6689C28.3424 19.6689 28.6619 19.7314 28.9674 19.8564C29.273 19.9814 29.5438 20.162 29.7799 20.3981C30.1827 20.8009 30.5299 21.0648 30.8216 21.1898C31.1133 21.3148 31.5508 21.3773 32.1341 21.3773C32.8286 21.3773 33.4188 21.6203 33.9049 22.1064C34.3911 22.5926 34.6341 23.1828 34.6341 23.8773C34.6341 24.4606 34.6966 24.8981 34.8216 25.1898C34.9466 25.4814 35.2105 25.8287 35.6133 26.2314C35.8494 26.4676 36.0299 26.7384 36.1549 27.0439C36.2799 27.3495 36.3424 27.6689 36.3424 28.0023C36.3424 28.3356 36.2799 28.6551 36.1549 28.9606C36.0299 29.2662 35.8494 29.537 35.6133 29.7731C35.2105 30.1759 34.9466 30.5231 34.8216 30.8148C34.6966 31.1064 34.6341 31.5439 34.6341 32.1273C34.6341 32.8217 34.3911 33.412 33.9049 33.8981C33.4188 34.3842 32.8286 34.6273 32.1341 34.6273C31.5508 34.6273 31.1133 34.6898 30.8216 34.8148C30.5299 34.9398 30.1827 35.2037 29.7799 35.6064C29.5438 35.8426 29.273 36.0231 28.9674 36.1481C28.6619 36.2731 28.3424 36.3356 28.0091 36.3356ZM30.0924 31.3356C30.4397 31.3356 30.7348 31.2141 30.9779 30.971C31.2209 30.728 31.3424 30.4328 31.3424 30.0856C31.3424 29.7384 31.2209 29.4432 30.9779 29.2002C30.7348 28.9571 30.4397 28.8356 30.0924 28.8356C29.7452 28.8356 29.4501 28.9571 29.207 29.2002C28.964 29.4432 28.8424 29.7384 28.8424 30.0856C28.8424 30.4328 28.964 30.728 29.207 30.971C29.4501 31.2141 29.7452 31.3356 30.0924 31.3356ZM25.3008 30.7106C25.4674 30.8773 25.6619 30.9606 25.8841 30.9606C26.1063 30.9606 26.3008 30.8773 26.4674 30.7106L30.7174 26.4814C30.8841 26.3148 30.9674 26.1169 30.9674 25.8877C30.9674 25.6585 30.8841 25.4606 30.7174 25.2939C30.5508 25.1273 30.3529 25.0439 30.1237 25.0439C29.8945 25.0439 29.6966 25.1273 29.5299 25.2939L25.3008 29.5439C25.1341 29.7106 25.0508 29.9051 25.0508 30.1273C25.0508 30.3495 25.1341 30.5439 25.3008 30.7106ZM26.8112 26.8044C27.0543 26.5613 27.1758 26.2662 27.1758 25.9189C27.1758 25.5717 27.0543 25.2766 26.8112 25.0335C26.5681 24.7905 26.273 24.6689 25.9258 24.6689C25.5786 24.6689 25.2834 24.7905 25.0404 25.0335C24.7973 25.2766 24.6758 25.5717 24.6758 25.9189C24.6758 26.2662 24.7973 26.5613 25.0404 26.8044C25.2834 27.0474 25.5786 27.1689 25.9258 27.1689C26.273 27.1689 26.5681 27.0474 26.8112 26.8044Z",
    fill: "white",
    style: {
      fill: "white",
      fillOpacity: 1
    }
  })))), /*#__PURE__*/React.createElement("defs", null, _filter || (_filter = /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_7121_143699",
    x: 0,
    y: 0,
    width: 64,
    height: 64,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 4,
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 8
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 1 0 0 0 0 0.909804 0 0 0 0 0.517647 0 0 0 0.4 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_7121_143699"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_7121_143699",
    result: "shape"
  }))), _filter2 || (_filter2 = /*#__PURE__*/React.createElement("filter", {
    id: "filter1_d_7121_143699",
    x: 16.6758,
    y: 16.6689,
    width: 28.668,
    height: 28.667,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 3,
    dy: 3
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 1 0 0 0 0 0.627451 0 0 0 0 0.360784 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_7121_143699"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_7121_143699",
    result: "shape"
  }))), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_7121_143699",
    x1: 12,
    y1: 12,
    x2: 44,
    y2: 44,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFE884",
    style: {
      stopColor: "#FFE884",
      stopColor: "color(display-p3 1.0000 0.9114 0.5165)",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFA05C",
    style: {
      stopColor: "#FFA05C",
      stopColor: "color(display-p3 1.0000 0.6265 0.3597)",
      stopOpacity: 1
    }
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDeliFreeIcon);
export default __webpack_public_path__ + "static/media/deli_free_icon.b18206b146ddfa2306c3de15dcd20b7e.svg";
export { ForwardRef as ReactComponent };